// The fields on the "create visit" form a doctor can show or hide from their
// settings. Keep in step with `visitFields` on the Setting model.
//
// `labelKey` is a translation key, with a plain-English fallback for the ones the
// locale files don't carry yet.
//
// `defaultVisible: false` marks a field that stays off until the doctor switches
// it on. Everything else is on until switched off.
export const VISIT_FIELDS = [
    { key: 'complaints', labelKey: 'complaints', fallback: 'Complaints' },
    { key: 'diagnosis', labelKey: 'diagnosis', fallback: 'Diagnosis' },
    { key: 'gpm', labelKey: 'gpm', fallback: 'GPM' },
    { key: 'lmp', labelKey: 'lmp', fallback: 'LMP' },
    { key: 'edd', labelKey: 'edd', fallback: 'EDD' },
    { key: 'dngh', labelKey: 'dngh', fallback: 'DNGH' },
    { key: 'psh', labelKey: 'psh', fallback: 'PSH' },
    { key: 'pmh', labelKey: 'pmh', fallback: 'PMH' },
    { key: 'xray', labelKey: 'xray', fallback: 'X-ray' },
    { key: 'ctScan', labelKey: 'ctScan', fallback: 'CT scan' },
    { key: 'ultrasound', labelKey: 'ultrasound', fallback: 'Ultrasound' },
    { key: 'vitalSigns', labelKey: 'vitalSigns', fallback: 'Vital signs' },
    { key: 'prescriptions', labelKey: 'prescriptions', fallback: 'Prescriptions' },
    { key: 'labTests', labelKey: 'labTests', fallback: 'Lab tests' },
    { key: 'attachments', labelKey: 'attachments', fallback: 'Attachments' },
    { key: 'notes', labelKey: 'notes', fallback: 'Notes' },
    { key: 'nextVisitDate', labelKey: 'nextVisitDate', fallback: 'Next visit date' },
    // Obs & Gyn fields, hidden until the doctor turns them on.
    { key: 'onExamination', labelKey: 'onExamination', fallback: 'On Examination', defaultVisible: false },
    { key: 'pelvicUs', labelKey: 'pelvicUs', fallback: 'Pelvic US', defaultVisible: false },
    { key: 'obstetricUs', labelKey: 'obstetricUs', fallback: 'Obstetric US', defaultVisible: false },
    // Dental and eye sections, switched on for dentists and eye doctors when
    // their account is created.
    { key: 'dental', labelKey: 'dental', fallback: 'Dental', defaultVisible: false },
    { key: 'eyeExam', labelKey: 'eyeExam', fallback: 'Eye examination', defaultVisible: false },
    { key: 'glasses', labelKey: 'glassesPrescription', fallback: 'Glasses prescription', defaultVisible: false }
];

export const VISIT_FIELD_KEYS = VISIT_FIELDS.map((field) => field.key);

const DEFAULT_VISIBLE = VISIT_FIELDS.reduce(
    (acc, field) => ({ ...acc, [field.key]: field.defaultVisible !== false }),
    {}
);

// A field the doctor has never decided on falls back to its own default: on for
// the ordinary fields, off for the speciality ones. Written this way on purpose:
// a doctor whose settings predate this feature, or a settings request that
// failed, must still get the complete form rather than a blank one.
export const isVisitFieldVisible = (visitFields, key) => {
    const saved = visitFields?.[key];
    return typeof saved === 'boolean' ? saved : DEFAULT_VISIBLE[key] !== false;
};

// Per-field defaults, for before the settings have loaded.
export const defaultVisitFields = () => ({ ...DEFAULT_VISIBLE });
